<template>
    <div class="wrapper"
         :class="[
      { 'nav-open': $sidebar.showSidebar }
    ]">
        <notifications></notifications>
        <side-bar :active-color="sidebarBackground"
                  :background-image="sidebarBackgroundImage"
                  :data-background-color="sidebarBackgroundColor">
            <!--            <user-menu :title="user.name"></user-menu>-->
            <mobile-menu></mobile-menu>
            <template slot="links" v-if="activeAccount">

              <sidebar-item :link="{ name: $t('menu.orders'), path: '/orders/myorders' }"></sidebar-item>

              <li>
              <a
                  href="#"
                  class="nav-link sidebar-menu-item"
                  @click.prevent="logout"
              >
                <md-icon>lock</md-icon>
                <p>
                  {{ $t('menu.logout') }}
                </p>
              </a>
              </li>

              <sidebar-item  v-show="activeAccount && isEmployee"
                        :link="{ name: $t('menu.dashboard'), icon: 'dashboard', path: '/' + activeAccount.mys_account+'/dashboard' }">
                </sidebar-item>

<!--                <sidebar-item :link="{ name: $t('menu.orders'), icon: 'receipt' }">-->


                <sidebar-item :link="{ name: $t('menu.shipping'), icon: 'local_shipping' }" v-show="activeAccount && isEmployee">
                    <sidebar-item
                            :link="{ name: $t('menu.pickandpair'), path: '/' + activeAccount.mys_account+'/shipping/upcoming' }"></sidebar-item>
                </sidebar-item>

                <!--<sidebar-item :link="{ name: 'Customers', icon: 'people' }">
                    <sidebar-item :link="{ name: 'New order', path: '/customers/orders', icon : 'add' }"></sidebar-item>
                </sidebar-item>-->
            </template>

        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

<!--            <fixed-plugin :color.sync="sidebarBackground"-->
<!--                          :colorBg.sync="sidebarBackgroundColor"-->
<!--                          :sidebarMini.sync="sidebarMini"-->
<!--                          :sidebarImg.sync="sidebarImg"-->
<!--                          :image.sync="sidebarBackgroundImage">-->
<!--            </fixed-plugin>-->

            <div :class="{ content: !$route.meta.hideContent }"
                 @click="toggleSidebar">
                <zoom-center-transition :duration="200" mode="out-in">
                    <!-- your content here -->
                    <router-view></router-view>
                </zoom-center-transition>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
<script>
    /* eslint-disable no-new */
    import PerfectScrollbar from "perfect-scrollbar";
    import "perfect-scrollbar/css/perfect-scrollbar.css";

    function hasElement(className) {
        return document.getElementsByClassName(className).length > 0;
    }

    function initScrollbar(className) {
        if (hasElement(className)) {
            new PerfectScrollbar(`.${className}`);
        } else {
            // try to init it later in case this component is loaded async
            setTimeout(() => {
                initScrollbar(className);
            }, 100);
        }
    }

    import TopNavbar from "./TopNavbar.vue";
    import ContentFooter from "./ContentFooter.vue";
    import MobileMenu from "./Extra/MobileMenu.vue";
    import FixedPlugin from "../../FixedPlugin.vue";
    import UserMenu from "./Extra/UserMenu.vue";
    import {ZoomCenterTransition} from "vue2-transitions";
    import store from '../../../store';
    import {mapGetters} from 'vuex';
    import StorageService from '@/services/StorageService'

    export default {
        components: {
            TopNavbar,
            ContentFooter,
            MobileMenu,
            FixedPlugin,
            UserMenu,
            ZoomCenterTransition
        },
        data() {
            return {
                sidebarBackgroundColor: "black",
                sidebarBackground: "green",
                sidebarBackgroundImage: "./img/sidebar-2.jpg",
                sidebarMini: true,
                sidebarImg: true
            };
        },
        computed: {
            ...mapGetters(["user", "activeAccount"]),
            isEmployee() {
                if (!this.activeAccount.roleName)
                    return false;
                return this.activeAccount.roleName.toLowerCase() === "sys admin" || this.activeAccount.roleName.toLowerCase() === "logistics";
            }
        },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            },
            minimizeSidebar() {
                if (this.$sidebar) {
                    this.$sidebar.toggleMinimize();
                }
            },
          logout(){
            store.commit("SET_TOKEN",null);
            StorageService.removeItem("mys_token");
            document.location = "/#/login";
          },
        },
        mounted() {


            store.dispatch("loadUser");
        },

        watch: {
            user(user) {
                if (!user)
                    return;


                if (this.user.roles && this.user.roles.length > 0) {

                    store.commit("SET_ACCOUNT", user.roles[0]);

                    if (!this.$route.params.accountId && user.roles && user.roles.length > 0)
                        store.commit("SET_ACCOUNT", user.roles[0]);
                    else
                        store.commit("SET_ACCOUNT", user.roles.filter(r => r.mys_account == this.$route.params.accountId)[0])

                    if (!this.$route.name || !this.$route.params.accountId) {
                        this.$router.push({name: "Dashboard", params: {accountId: user.roles[0].mys_account}});
                    }
                }


            },
            sidebarMini() {
                this.minimizeSidebar();
            }
        }
    };
</script>
<style lang="scss">
    $scaleSize: 0.95;
    @keyframes zoomIn95 {
        from {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }

        to {
            opacity: 1;
        }

    }

    .main-panel .zoomIn {
        animation-name: zoomIn95;
    }

    @keyframes zoomOut95 {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
    }

    .main-panel .zoomOut {
        animation-name: zoomOut95;
    }
</style>
